/* ss-apertura · intro «¡Ya abrimos!» · Say Simon · vie 16-oct-2026 (pedido de Leo). Lo pone snippets/ss-apertura.liquid con defer.
   UNIÓN (Leo, vie 16-oct): una sola celebración por persona entre esta animación y la tarjeta ss-bienvenida de la home, con la
   MISMA llave (ss_bienvenida_v1) y la misma ventana (vie 16 21:00 → dom 18 23:59 CDMX). En la home, ss-bienvenida decide, tapa la
   página con una cortina y deja window.ssUnion: aquí se toma, sale la animación (≈ 2.2 s) y al cerrarla se abre la tarjeta.
   En las demás páginas: solo la animación. Nunca en carrito.
   Dura ≈ 2.8 s y se cierra sola; se salta tocando, con Esc o con «Entrar». El foco va a «Entrar» y regresa al cerrar.
   Prueba para QA: ?ss_apertura=1 (ignora fecha y visita; no guarda nada). Sin localStorage → NO sale (para no repetirla). */
(function () {
  var INICIO = Date.UTC(2026, 9, 17, 3, 0, 0);          // vie 16-oct 21:00 CDMX (UTC−6)
  var FIN = Date.UTC(2026, 9, 19, 5, 59, 59, 999);      // dom 18-oct 23:59:59 CDMX
  var CLAVE = "ss_bienvenida_v1", DURA = 2800;
  var U = window.ssUnion;                               // solo existe en la home cuando a la persona SÍ le toca la bienvenida
  var tpl = document.getElementById("ss-apertura-tpl");
  if (!tpl || !("content" in tpl)) return;
  var prueba = /[?&]ss_apertura=1(&|$)/.test(location.search);
  if (U) DURA = 2200;                                   // en la home la animación es más corta: después viene la tarjeta
  if (!U && document.getElementById("ss-bienvenida")) return;   // home sin bienvenida (ya la vio o fuera de ventana): nada
  if (/^\/(cart|checkout|password)/.test(location.pathname) && !prueba) return;
  if (document.querySelector("dialog.ssb[open]") || document.documentElement.classList.contains("ssb-on")) return;   // la tarjeta ya abrió
  if (U) { U.tomar(); }                                 // la decisión ya la tomó ss-bienvenida (ventana, llave, prueba)
  else if (!prueba) {
    var ahora = Date.now();
    if (ahora < INICIO || ahora > FIN) return;
    try { if (localStorage.getItem(CLAVE)) return; } catch (e) { return; }   // una sola celebración (llave compartida)
  }
  var script = document.currentScript || document.querySelector("script[data-css][src*='ss-apertura']");
  var css = script && script.getAttribute("data-css");
  var quieto = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  function confeti(caja) {
    if (quieto) return;
    var colores = ["#FFDD50", "#FFFFFF", "#FFE473", "#FFF1B9"], n = window.innerWidth < 600 ? 28 : 44, h = "";
    for (var i = 0; i < n; i++) {
      h += '<i style="--x:' + (Math.random() * 100).toFixed(1) + "%;--w:" + (6 + Math.random() * 6).toFixed(1) + "px;--c:" + colores[i % 4] +
        ";--d:" + (1.4 + Math.random() * 1.1).toFixed(2) + "s;--r:" + (Math.random() * .5).toFixed(2) + "s;--dx:" + ((Math.random() - .5) * 30).toFixed(1) +
        "vw;--g:" + Math.round((Math.random() - .5) * 900) + 'deg"></i>';
    }
    caja.innerHTML = h;
  }

  function mostrar() {
    if (U) { if (U.abierta()) return; U.guarda(); }       // en la home guarda ss-bienvenida (respeta su prueba)
    else if (!prueba) { try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) { return; } }   // se marca al salir de verdad
    var raiz = tpl.content.firstElementChild.cloneNode(true);
    var antes = document.activeElement, cerrada = false, t;
    function cerrar() {
      if (cerrada) return; cerrada = true; clearTimeout(t);
      document.removeEventListener("keydown", tecla, true);
      raiz.classList.add("ss-ap--sale");
      setTimeout(function () {
        raiz.remove();
        if (U) { U.abrir(); return; }                   // la tarjeta amarilla trae su propio foco (autofocus en «Entrar a la tienda»)
        if (antes && antes.focus && document.contains(antes)) { try { antes.focus({ preventScroll: true }); } catch (e) {} }
      }, quieto ? 0 : 300);
    }
    function tecla(e) {
      if (e.key === "Escape" || e.key === "Esc") { e.preventDefault(); cerrar(); }
      else if (e.key === "Tab") { e.preventDefault(); boton.focus(); }   // el foco no se sale del aviso mientras está
    }
    confeti(raiz.querySelector(".ss-ap__confeti"));
    var boton = raiz.querySelector(".ss-ap__entrar");
    raiz.addEventListener("click", cerrar);
    document.addEventListener("keydown", tecla, true);
    document.body.appendChild(raiz);
    try { boton.focus({ preventScroll: true }); } catch (e) { boton.focus(); }
    t = setTimeout(cerrar, quieto ? DURA + 1200 : DURA);
  }

  function cuandoCargue(fn) {
    if (U || document.readyState === "complete") fn();   // en la home la cortina ya tapa: no hay que esperar a «load»
    else window.addEventListener("load", fn, { once: true });
  }
  cuandoCargue(function () {
    if (!css) return mostrar();
    var l = document.createElement("link"); l.rel = "stylesheet"; l.href = css;
    var listo = false, ir = function () { if (!listo) { listo = true; mostrar(); } };
    var sinIntro = function () { if (!listo) { listo = true; if (U) U.abrir(); } };   // sin CSS no sale; en la home, directo a la tarjeta
    l.onload = ir; l.onerror = sinIntro;
    setTimeout(sinIntro, U ? 2500 : 4000);                            // si tarda, ya no sale (la persona ya está navegando)
    document.head.appendChild(l);
  });
})();
